import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemServiceV2 from "../../../services/inventory_appCommonService";
import {useSelector } from "react-redux"; //useDispatch
import { InputField } from "../../../Components/formElements/InputField";
import Constants from "../../../common/SupplierConstants";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import {
  validateName,
  validPostalCode,
} from "../../../common/Validations";
// import toast from "react-hot-toast";
import Layout from "../../../Layout/Layout";
import toast from "react-hot-toast";
import { useRef } from "react";
import DraftModal from "../../../Components/CancleModal/DraftModal";
const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};
const AttendanceDetails = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const historyGuardRef = useRef(false);
  let userData = useSelector((state) => state?.user?.data);
  let attendance = useSelector(
    (state) => state?.hr?.atd?.atdNr,
  );
  const [isCardVisible, setCardVisible] = useState(true);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields /*setErrorFields*/] = useState([]);
  const [validation, setValidation] = useState({
    organisationName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "driverName" ? value : "")
      ? (errors.driverName = "")
      : (errors.driverName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
  });
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const handleDiscardDraft = () => {
    setShowDraftModal(false);
    setIsEditMode(false);
    historyGuardRef.current = false;
    loadIntialData1();
  };
  const loadIntialData1 = async (page) => {
    if (attendance) {
      let obj = {
        queryName:"Get_HRAttendance_Details",
        documentNumber: attendance,
      };
      await ItemServiceV2.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
    }
  };

  useEffect(() => {
    loadIntialData1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };
  const handleSaveClick = async () => {
    if (isDraftSaving) return;
    setIsDraftSaving(true);
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {
      const payload = {
        ...formInputs,
      };

      const response = await ItemServiceV2.updateWarehouseDocument(payload);

      if (response?.status === 200) {
        toast.dismiss(toastId);
        toast.success("Warehouse updated successfully", {
          position: "top-right",
        });

        setIsEditMode(false);
        loadIntialData1();
      } else {
        toast.dismiss(toastId);
        toast.error(response?.message || "Failed to update warehouse", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    } finally {
      setIsDraftSaving(false);
    }
  };
  //bank end
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Attendance Details{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {attendance}
              </span>
              <span>
                {formInputs?.headerStatus === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : formInputs?.headerStatus === "PO Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Draft" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Created" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Deleted" ? (
                  <span className="bg-table-status bg-table-delete-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : (
                  formInputs?.headerStatus
                )}
              </span>
            </h2>
            <p className="subText">
              Details as a Attendance or Sub-Contractor with our Company
            </p>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AD</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Attendance</span>
                      <span className="subHeaderTitle">Attendance Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Warehouse Name"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Employee Name
                            </>
                          }
                          extraLabel=""
                          name="employeeName"
                          placeholder=""
                          value={formInputs?.employeeName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.employeeName}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Warehouse Name"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Employee Code
                            </>
                          }
                          extraLabel=""
                          name="employeeCode"
                          placeholder=""
                          value={formInputs?.employeeCode || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.employeeCode}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label=" Address Lines 1 / Street"
                          label={
                            <>
                              <i className="bi bi-signpost-2 labelIcon"></i>
                              Attendance Date
                            </>
                          }
                          name="attendanceDate"
                          placeholder=""
                          value={formInputs?.attendanceDate || ""}
                          onChange={onInputChange}
                          error={validation.attendanceDate}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Address Line 2"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Start Time
                            </>
                          }
                          name="startTime"
                          placeholder=""
                          value={formInputs?.startTime || ""}
                          onChange={onInputChange}
                          error={validation.startTime}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="City"
                          label={
                            <>
                              <i className="bi bi-buildings labelIcon"></i>
                              End Time
                            </>
                          }
                          name="endTime"
                          placeholder=""
                          value={formInputs?.endTime || ""}
                          onChange={onInputChange}
                          error={validation.endTime}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Postal Code/PO Box"
                          label={
                            <>
                              <i className="bi bi-mailbox labelIcon"></i>
                              Created By
                            </>
                          }
                          name="createdBy"
                          placeholder=""
                          value={formInputs?.createdBy}
                          onChange={onInputChange}
                          error={validation.createdBy}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        // failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <DraftModal
        show={showDraftModal}
        onHide={() => !isDraftSaving && setShowDraftModal(false)}
        type="warehouse"
        title="Save as Draft"
        formData={formInputs}
        onConfirm={handleSaveClick}
        onDiscard={handleDiscardDraft}
        loading={isDraftSaving}
      />
    </main>
  );
};

export default AttendanceDetails;
